import * as React from 'react';
import {
    Stack,
    Button,
    Typography,
    useTheme,
    IconButton,
} from '@mui/material';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from 'react-router-dom';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export default function Home(props) {
    const theme = useTheme();
    const sliderRef = React.useRef(null);
    const navigate = useNavigate();
    const { language } = useSelector(state => state.app);

    const images = [...Array(4).keys()].map(i => `public/images/frontpage/${i + 1}.png`);
    const descriptions = [...Array(4).keys()].map(i => t(`homePage.text${i + 1}`));

    const bgIndex = Math.ceil(Math.random() * 9)
    const bgSuffix = window.devicePixelRatio >= 2 ? '_4k' : '_hd'
    const [backim, setBackim] = React.useState(`/public/images/backgroundimages/optimized/bgim${bgIndex}${bgSuffix}.webp`)

    const sliderSettings = {
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 600,
        autoplaySpeed: 5000,
        pauseOnHover: true,
    };

    const nextSlide = () => sliderRef.current.slickNext();
    const prevSlide = () => sliderRef.current.slickPrev();

    return (
        <>
            <Box
                className="panning-background"
                sx={{
                    zIndex: -1,
                    position: 'absolute',
                    width: "100%",
                    height: "100%",
                    filter: "brightness(50%) blur(4px)", 
                    backgroundImage: `url(${backim})`,
                    backgroundSize: 'cover',
                    animation: "panning ease-out 100s infinite",
                }}
            />
            {/* Main Content Layout */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    gap: 4,
                    width: '100%',
                    p: { xs: 2, md: 4 },
                }}>

                {/* Left Side: Text Content */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    maxWidth: { xs: '90vw', md: '45vw' },
                    width: '100%',
                }}>
                    
                    {/* <Box component="img" src="public/assets/dash_gross.svg" sx={{ width: "60px", height: "auto" }} /> */}
                    <Box component="img" src="public/images/logobanner.png" sx={{ width: "100%", maxWidth: "400px",borderRadius:2 }} />

                   
                    <Box
                        sx={{
                            p: 3,
                            backgroundColor: 'background.paper', 
                            borderRadius: 2,
                            boxShadow: theme.shadows[3],
                            
                        }}>
                       
                        <Typography variant="h5" component="h1">
                            {t("homePage.dataText")}
                        </Typography>
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                      
                        color: "#FFFFFF",
                        maxWidth: "100%",
                        fontSize: 16,
                        typography: theme.typography.body1,
                    }}>
                        {t("homePage.description")}
                       
                        <Button variant="contained" onClick={() => navigate(`${language}/usecase`)} sx={{ width: 'fit-content', mt: 1 }}>
                            {t("homePage.moreInfo")}
                        </Button>
                    </Box>
                </Box>

                {/* Right Side: Image Slider */}
                <Box sx={{
                    position: 'relative',
                    width: '100%',
                    height: { xs: 'auto', md: '35vw' },
                    aspectRatio: '1/1',
                    maxWidth: { xs: '90vw', md: '45vw' },
                    
                    '& .slick-slider, & .slick-list, & .slick-track, & .slick-slide > div': {
                        height: '100%',
                    },
                }}>
                    <Slider ref={sliderRef} {...sliderSettings}>
                        {images.map((image, index) => (
                            <Box sx={{ position: 'relative', height: '100%' }} key={image}>
                                <Box component='img' src={image} alt={`Showcase image ${index + 1}`} sx={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: 2 }} />
                                <Stack
                                    justifyContent="flex-end"
                                    position="absolute"
                                    bottom={0}
                                    width={"100%"}
                                    height={"50%"}
                                    sx={{ 
                                        p: 3,
                                        background: 'linear-gradient(to top, rgba(0,0,0,0.85), transparent)',
                                        borderRadius: '0 0 8px 8px'
                                    }}
                                >
                                    <Box sx={{ color: 'common.white', pb: 5 }}>
                                        {descriptions[index]}
                                    </Box>
                                </Stack>
                            </Box>
                        ))}
                    </Slider>
                    <IconButton sx={{ position: 'absolute', bottom: 20, left: 16, color: 'common.white', background: 'rgba(0,0,0,0.5)', '&:hover': {background: 'rgba(0,0,0,0.7)'} }} onClick={prevSlide}>
                        <ArrowBackIosNewIcon />
                    </IconButton>
                    <IconButton sx={{ position: 'absolute', bottom: 20, right: 16, color: 'common.white', background: 'rgba(0,0,0,0.5)', '&:hover': {background: 'rgba(0,0,0,0.7)'} }} onClick={nextSlide}>
                        <ArrowForwardIosIcon />
                    </IconButton>
                </Box>
            </Box>
        </>
    );
}